import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { languageHelper } from "../../../config/helperFunctions";

function ViewModifiers() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  
  const { id } = useParams();
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${apiKey}/api/rms/admin/modifiers/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err.resposne.data.message);
        })
        .finally(() => {
          setPageLoading(false);
        });
    };

    handleCSRF(fetchData);
  }, [id, user?.token]);

  if (error) {
    return (
      <div
        className="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 me-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">{languageHelper("Info")}</span>
        <div>{error}</div>
      </div>
    );
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">{languageHelper("Modifier")}</h1>
        </div>
        <div className="w-full space-y-4">
          <div className="grid grid-cols-3">
            <div>
              <h2 className="text-d-bg-text text-xl">{languageHelper("Name")}</h2>
              <p className="text-gray-700 text-sm">{data.name}</p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">{languageHelper("Price")}</h2>
              <p className="text-gray-700 text-sm">{data.price}</p>
            </div>
            <div>
              <h2 className="text-d-bg-text text-xl">{languageHelper("Description")}</h2>
              <p className="text-gray-700 text-sm">{data.description}</p>
            </div>
          </div>
          <div>
            <h2 className="text-d-bg-text text-xl">{languageHelper("Ingredient Consumptions")}</h2>
            <table className="w-full text-sm text-left rtl:text-right">
              <thead className="uppercase font-medium">
                <tr>
                  <th className="px-6 py-3">{languageHelper("SN")}</th>
                  <th className="px-6 py-3">{languageHelper("Ingredient")}</th>
                  <th className="px-6 py-3">{languageHelper("Consumption")}</th>
                </tr>
              </thead>
              <tbody>
                {data.modifier_ingredients.map((ing, index) => (
                    <tr key={index}>
                        <td className="px-6 py-1">
                            {index + 1}
                        </td>
                        <td className="px-6 py-1">
                            {ing.ingredient.name}
                        </td>
                        <td className="px-6 py-1">
                            {ing.consumption}
                        </td>
                    </tr>
                ))}
              </tbody>
            </table>
          </div>
            <span className="w-full bg-d-bg-text h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <Link
                className="bg-d-bg-text text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                to={`/admin/modifiers/addModifiers/${id}`}
              >
                {languageHelper("Edit")}
              </Link>
              <button
                className="bg-d-bg-text text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
        </div>
      </div>
    </main>
  );
}

export default ViewModifiers;
